<template>
    <div class="city-picker-template" v-html="cityName"/>
</template>

<script>
    export default {
        props: {
            item: {required: true},
            searchText: {required: true}
        },

        computed: {
            cityName() {
                if (!!this.item.dummy) {
                    return 'Совпадений не найдено.<br />Выберите ближайший населенный пункт.';
                } else {
                    return this.item.name;
                }
            }
        }
    }
</script>